<template>
  <!-- The one composition every pre-auth view shares: a brand-tinted page,
       a theme toggle in the corner, ONE centred card, and the help/legal
       strip under it. The views used to carry their own copies of the glows
       and footnote; the strip and the toggle now come for free. -->
  <div class="sh-page">
    <div class="sh-page__glow sh-page__glow--one" aria-hidden="true"></div>
    <div v-if="wide" class="sh-page__glow sh-page__glow--two" aria-hidden="true"></div>

    <!-- Page controls, outside the card: the language (D4 — from the first
         screen) and the theme. They read as page controls, not as part of
         the sign-in form. -->
    <div class="sh-page__controls">
      <LocaleSwitch />
      <button
        type="button"
        class="sh-page__theme"
        :aria-label="darkMode ? t('theme.toLight') : t('theme.toDark')"
        :title="darkMode ? t('theme.light') : t('theme.dark')"
        @click="toggleTheme"
      >
        <Transition name="sh-icon-swap" mode="out-in">
          <v-icon :key="darkMode ? 'sun' : 'moon'" size="18">{{ darkMode ? "light_mode" : "dark_mode" }}</v-icon>
        </Transition>
      </button>
    </div>

    <div class="sh-card" :class="[{ 'sh-card--wide': wide }, cardClass]">
      <slot />
    </div>

    <PreAuthFooter v-if="footer" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import LocaleSwitch from "@/i18n/LocaleSwitch.vue";
import PreAuthFooter from "./PreAuthFooter.vue";
import { useThemeToggle } from "./useThemeToggle";

export default defineComponent({
  name: "PreAuthPage",
  components: { LocaleSwitch, PreAuthFooter },
  props: {
    /** Login uses the wider card and the second glow. */
    wide: { type: Boolean, default: false },
    /** Off for a page with no resolved tenant (nothing to link to). */
    footer: { type: Boolean, default: true },
    cardClass: { type: [String, Array, Object], default: "" },
  },
  setup() {
    const { t } = useI18n();
    return { t, ...useThemeToggle() };
  },
});
</script>
